var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopyPaste48Line = function SvgIconCopyPaste48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 40.2H21.1a5.31 5.31 0 0 1-5.3-5.3V19.1c0-2.92 2.38-5.3 5.3-5.3h11.8c2.92 0 5.3 2.38 5.3 5.3v15.8c0 2.92-2.38 5.3-5.3 5.3Zm-11.8-23a1.9 1.9 0 0 0-1.9 1.9v15.8c0 1.05.85 1.9 1.9 1.9h11.8a1.9 1.9 0 0 0 1.9-1.9V19.1a1.9 1.9 0 0 0-1.9-1.9H21.1Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 32.5H9.8V13.1c0-2.92 2.38-5.3 5.3-5.3h15.4v3.4H15.1a1.9 1.9 0 0 0-1.9 1.9v19.4Z",
    fill: "current"
  })));
};
export default SvgIconCopyPaste48Line;